import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Box from '@components/layout/box';
import Typography from '@components/basics/typography';
import CircleRightArrowIcon from '@components/basics/icons/circle-right-arrow';

interface MetricsWidgetProps {
  className?: string;
  title: string;
  subtitle: string;
  onClick: () => void;
}

const MetricsWidget: FunctionComponent<MetricsWidgetProps> = ({
  className,
  children,
  title,
  subtitle,
  onClick,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);
  return (
    <Box
      className={className || ''}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <InfoWrapper>
        <div>
          <Title type="title" customFont="bold">
            <Translate id={title} />
          </Title>
          <Text customFont="medium">
            <Translate id={subtitle} />
          </Text>
        </div>
        <CircleRightArrowIcon isWhite isHovered={isHovered} />
      </InfoWrapper>
      {children}
    </Box>
  );
};

export default styled(MetricsWidget)`
  cursor: pointer;
  height: max-content;
`;

const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

const Title = styled(Typography)`
  margin-bottom: 5px;
`;

const Text = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.span};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.tertiary};
`;
